import { render, staticRenderFns } from "./EditEmailModal.vue?vue&type=template&id=db4a521e&scoped=true&"
import script from "./EditEmailModal.vue?vue&type=script&lang=js&"
export * from "./EditEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4a521e",
  null
  
)

export default component.exports